import { GoGear } from 'react-icons/go';
import {
  IoIosArrowBack,
  IoIosArrowForward,
  IoMdHelp,
  IoMdPower,
} from 'react-icons/io';
import { IoDocumentAttachOutline } from 'react-icons/io5';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { MdLanguage } from 'react-icons/md';
import Icon from '@mdi/react';
import { mdiAnimationPlay, mdiTableOfContents } from '@mdi/js';
import { GiCctvCamera } from 'react-icons/gi';
import { ClickBttn } from './buttons/click-button';

import {
  cameraBttnClick,
  contactBttnClick,
  docsBttnClick,
  govieModeBttnClick,
  helpBttnClick,
  hotspotBttnClick,
  infoBttnClick,
  langBttnClick,
  playbarBttnClick,
  powerBttnClick,
  settingsBttnClick,
  // uspBttnClick,
} from '../../state/user-actions';

import { cl_sidebarBttn } from '../constants/html-classnames';
import {
  id_bttnArrowInSidebar,
  id_bttnContactInSidebar,
  id_bttnDocsInSidebar,
  id_bttnPlaybarInSidebar,
  id_bttnHelpInSidebar,
  id_bttnHotspotInSidebar,
  id_bttnLangInSidebar,
  id_bttnPowerInSidebar,
  id_bttnSettingsInSidebar,
  // id_bttnUspInSidebar,
  id_bttnGovieModeInSidebar,
  id_bttnCameraInSidebar,
} from '../constants/html-ids';
import { transl } from '../localisation/translate';

export const InfoboxBttn = ({
  clIconState,
  isActive,
}: {
  clIconState: string;
  isActive: boolean;
}) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnArrowInSidebar}
    iconClass={clIconState}
    iconType={isActive ? <IoIosArrowBack /> : <IoIosArrowForward />}
    onBttnClick={infoBttnClick}
  />
);

export const SettingsBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnSettingsInSidebar}
    iconClass={clIconState}
    iconType={<GoGear />}
    onBttnClick={settingsBttnClick}
  />
);

export const HelpBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnHelpInSidebar}
    iconClass={clIconState}
    iconType={<IoMdHelp />}
    onBttnClick={helpBttnClick}
  />
);

/* export const LangBttn = ({
  clIconState,
  iso,
  dict,
}: {
  clIconState: string;
  iso: string;
  dict: Localisation.Dictionary;
}) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnLangInSidebar}
    iconClass={clIconState}
    iconType={<span>{transl(`#${iso}`, dict)}</span>}
    onBttnClick={langBttnClick}
  />
); */

export const LangBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnLangInSidebar}
    iconClass={clIconState}
    iconType={<MdLanguage />}
    onBttnClick={langBttnClick}
  />
);

/* export const UspBttn = ({
  clIconState,
  dict,
}: {
  clIconState: string;
  dict: Default.Str2StrMap;
}) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnUspInSidebar}
    iconClass={clIconState}
    iconType={<span>{transl('#sidebar|usp', dict)}</span>}
    onBttnClick={uspBttnClick}
  />
); */

export const ContactBttn = ({
  clIconState,
  dict,
}: {
  clIconState: string;
  dict: Default.Str2StrMap;
}) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnContactInSidebar}
    iconClass={clIconState}
    iconType={<span>{transl('#sidebar|contact', dict)}</span>}
    onBttnClick={contactBttnClick}
  />
);

export const DocsBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnDocsInSidebar}
    iconClass={clIconState}
    iconType={<IoDocumentAttachOutline />}
    onBttnClick={docsBttnClick}
  />
);

export const PowerBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnPowerInSidebar}
    iconClass={clIconState}
    iconType={<IoMdPower />}
    onBttnClick={powerBttnClick}
  />
);

export const HotspotBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnHotspotInSidebar}
    iconClass={clIconState}
    iconType={<AiOutlineInfoCircle />}
    onBttnClick={hotspotBttnClick}
  />
);

export const GovieModeBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnGovieModeInSidebar}
    iconClass={clIconState}
    iconType={<Icon path={mdiAnimationPlay} size={1.2} />}
    onBttnClick={govieModeBttnClick}
  />
);

export const CameraBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnCameraInSidebar}
    iconClass={clIconState}
    iconType={<GiCctvCamera />}
    onBttnClick={cameraBttnClick}
  />
);

export const GovieMenuBttn = ({ clIconState }: { clIconState: string }) => (
  <ClickBttn
    bttnClass={cl_sidebarBttn}
    iconId={id_bttnPlaybarInSidebar}
    iconClass={clIconState}
    iconType={<Icon path={mdiTableOfContents} size={1.4} />}
    onBttnClick={playbarBttnClick}
  />
);
